const windowEnv = window?.env
const processEnv = process?.env
let env = processEnv?.REACT_APP_API_ENV === "development" ? processEnv : windowEnv

// Get API endpoints from environment variables
export const getAuth0Audience = () => {
  return env?.REACT_APP_AUTH0_AUDIENCE || "https://zippin-dashboard-dev/v1/"
}
export const getAuth0ClientId = () => {
  return env?.REACT_APP_AUTH0_CLIENT_ID || "ZUVxCG9100x15pi2INIXsI0rkCBwSYOw"
}
export const getZippinPlatformAPI = () => {
  return env?.REACT_APP_ZIPPIN_PLATFORM_API
}
export const getOperatorBackendAPI = () => {
  return env?.REACT_APP_OPERATOR_BACKEND_API
}
export const getDashboardUIURL = () => {
  return env?.REACT_APP_DASHBOARD_UI_URL
}
export const getCloudStorageURL = () => {
  return env?.REACT_APP_CLOUD_STORAGE_URL
}
export const isLocalEnv = () => {
  return env?.REACT_APP_API_ENV === "development"
}
export const getStoreConfigAPI = () => {
  return env?.REACT_APP_STORE_CONFIG_API
}
export const getZAPI = () => {
  return env?.REACT_APP_Z_API
}
export const getReactAppTurnServerPort = () => {
  return env?.REACT_APP_TURN_SERVER_PORT
}
export const getReactAppTurnServerKey = () => {
  return env?.REACT_APP_TURN_SERVER_KEY
}
export const getReactAppTurnServerHostnames = () => {
  let hostnames = env?.REACT_APP_TURN_SERVER_HOSTNAMES
  if (typeof hostnames === "string") {
    // remove whitespace before split on commas
    hostnames = hostnames.replace(/\s+/g, "").split(",")
  }
  return hostnames
}
export const getReactAppTurnServerHostnameDefault = () => {
  return env?.REACT_APP_TURN_SERVER_HOSTNAME_DEFAULT
}
export const getReactAppIceServerURL = () => {
  return env?.REACT_APP_ICE_SERVER_URL
}
export const getReactAppIceServerCredential = () => {
  return env?.REACT_APP_ICE_SERVER_CREDENTIAL
}
export const getReactAppIceServerUsername = () => {
  return env?.REACT_APP_ICE_SERVER_USERNAME
}
export const getDashboardServerAPI = () => {
  return env?.REACT_APP_ZIPPIN_DASHBOARD_SERVER_API
}
export const getTaskAssignerService = () => {
  return env?.REACT_APP_TASK_ASSIGNER
}

export const getTaskAssignmentRuleAPI = () => env?.REACT_APP_TASK_ASSIGNMENT_RULE_API

export const getTaskResultIngestorService = () => {
  return env?.REACT_APP_TASK_RESULT_INGESTOR
}
export const getSocketServer = () => {
  return env?.REACT_APP_SOCKET_SERVER
}
export const getSocketServerPath = () => {
  return env?.REACT_APP_SOCKET_SERVER_PATH
}
export const getTrackingAPI = () => {
  return env?.REACT_APP_TRACKING_API
}
export const getClipsManagerAPI = () => {
  return env?.REACT_APP_CLIPS_MANAGER_API
}
export const getMediaProxyServerAPI = () => {
  return env?.REACT_APP_MEDIA_PROXY_SERVER_API
}
export const getRBACBaseUrl = () => {
  return env?.REACT_APP_RBAC_BASE_URL
}
